export enum Features {
  ChatBot = "chatbot",
  ImageGeneration = "imageGeneration",
  Transcription = "transcription",
  Summary = "summary",
  Translation = "translation",
  SchornBox = "schornbox",
  CustomFeature = "CustomFeature",
}
